const headers = new Headers({ 'Content-Type': 'application/json' });

const fetchCart = async () => {
  try {
    const res = await fetch('/cart.js', {
      headers: headers
    });
    const data = await res.json();
    return {
      res: res,
      data: data
    }
  }
  catch (err) {
    return err
  }
}

const updateQty = async ({ value, variantId = null }, e = {}) => {
  if (!variantId) return;
  
  const { res, data } = await fetchCart();
  if (!res.ok) return;

  const hasTreeInCart = data.items.find(item => item.id === variantId);
  let formData;

  if (!hasTreeInCart) {
    formData = {
      items: [{
        id: variantId,
        quantity: value
      }]
    };
    
  } else {
    formData = {
      updates: {
        [hasTreeInCart.key]: value
      }
    };
  }

  try {
    const res = await fetch(hasTreeInCart ? '/cart/update.js' : '/cart/add.js', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(formData)
    });
    const data = await res.json();

    if (res.ok) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
            product: data
        }
      }));
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }
  catch (err) {
    console.log(err);
  }
  finally {
    e?.detail?.el?.classList.remove('is-loading');
  }
}

class PlantATree extends HTMLElement {
  constructor() {
    super();

    const qty = this.querySelector('input[name="quantity"]');
    if (!qty) return;
    const min = qty.getAttribute('min') ?? 1;

    qty.addEventListener('change', e => {
      const self = e.target;

      updateQty({
        value: +self.value <= min ? 1 : +self.value,
        variantId: +self.dataset.variantId,
      }, e);
    }, false);
  }
}
customElements.define('plant-a-tree', PlantATree);


class QtyWidget extends HTMLElement {
  constructor() {
    super();

    const input = this.querySelector('input');
    const buttons = this.querySelectorAll('button');

    if (!input) return;
    const min = input.getAttribute('min') ?? 1;

    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const self = e.target;
        const attr = self.dataset.adjust;
        let value = attr === 'decrement' ? +input.value - 1 : +input.value + 1;

        if (value < +min) return;
        input.value = value;
        input.dispatchEvent(new CustomEvent('change', {
          detail: {
            el: self,
          }
        }));
      });
    });
  }
}
customElements.define('qty-widget', QtyWidget);

/**
 * Automatically adds and delete 'plant-a-tree' product base on cart item length
 * Expect flashes on cart due to fetching of the cart 

document.addEventListener('minicart:updated', async (e) => {
  const plantTreeEl = document.querySelector('plant-a-tree');
  if (!plantTreeEl) return;

  const { res, data, data: { items }} = await fetchCart();
  if (!res.ok) return;

  const variantId = +plantTreeEl.dataset.variantId;
  const hasTreeInCart = data.items.find(item => item.id === variantId);

  if (items.length === 1) {
    if (!hasTreeInCart) {
      const input = plantTreeEl.querySelector('input');
      if (!input) return;
      input.dispatchEvent(new Event('change'));
    }
    else {
      const input = plantTreeEl.querySelector('input');
      if (!input) return;
      input.value = 0;
      input.dispatchEvent(new Event('change'));
    }
  }
}); */


document.addEventListener('DOMContentLoaded', async (e) => {
  const variantId = theme?.settings?.plant_a_tree_variant_id;

  console.log(variantId);
  if (!variantId) return;

  // Initially check cart on page load
  const { data } = await fetchCart();
  const hasTreeInCart = data.items.find(item => item.id === variantId);

  // Exit out if cart already has plant-a-tree product
  if (hasTreeInCart) return;

  const formData = {
    items: [{
      id: variantId,
      quantity: 1
    }]
  };

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(formData)
    });
    if (res.ok) {
      console.log('Tree added...')
      // const data = await res.json();
      // document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      //   detail: {
      //       product: data
      //   }
      // }));
    }
  }
  catch (err) {
    console.log(err);
  }
});